/**
	* @readonly
	* @enum {int}
	*/
export const ResellerPackageType = Object.freeze({
	Tiered3: 1,
	Tiered4: 2,
	Single: 3,
	SingleUnlimitedUsers: 4,
	Uncosted: 5,
	IndependentUpsells: 6
});